import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, tap, switchMap, Observable } from 'rxjs';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { GlobalComponent } from 'src/app/global-component';
import { OperationsModel } from '../../models/members/user/operations.model';
import { BaseListService } from './base-list.service';
import { OperationsSearchModel } from '../../models/members/user/operations-search.model';


@Injectable({
  providedIn: 'root'
})
export class OperationsService extends BaseListService implements OnDestroy {

  defaultOperationsListState: OperationsSearchModel = {
    sortColumnDirective: '',
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 1,
    sortColumn: '',
    sortDirection: 'desc',
    ids: [],
    name: "",
    searchTerm: undefined
  };

  private _resultItems$ = new BehaviorSubject<OperationsModel>({ ... new OperationsModel });
  protected override _state: OperationsSearchModel = { ...this.defaultOperationsListState };

  constructor(
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }

  protected _search(): Observable<OperationsModel> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getSecurityOperations(this._state);
  }

  clearListService() {
    this._state = { ...this.defaultOperationsListState };
    this._resultItems$.next(new OperationsModel);
  }
}